import throttle from 'lodash.throttle';
import { useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isDomainFolder, moveItemsDialog } from 'reactApp/appHelpers/appHelpers';
import { toolbarActions } from 'reactApp/appHelpers/toolbarActions';
import { setDragging } from 'reactApp/modules/selections/selections.actions';
import { SelectionsSelectors } from 'reactApp/modules/selections/selections.selectors';
import { showSnackbarAction } from 'reactApp/modules/snackbar/snackbar.actions';
import { SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';
import { getItemById } from 'reactApp/modules/storage/storage.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { RootState } from 'reactApp/store';

import { ETreeRootIds } from '../TreeComponent.data';

export const useDragAndDrop = (dragOverItem) => {
    const isDragging = useSelector(SelectionsSelectors.isDragging);
    const [isDraggingOver, setDraggingOver] = useState<boolean>(false);
    const itemsToDrop = useSelector(SelectionsSelectors.getSelectedItems);
    const dispatch = useDispatch();
    const { storage, id } = dragOverItem || {};
    const item = useSelector((state: RootState) => getItemById(state, id));
    const isValidDestination = !itemsToDrop.some((el) => el?.id === id);
    const isAllowedToDrop = [EStorageType.trashbin, EStorageType.home].includes(storage) && isValidDestination && dragOverItem.id !== ETreeRootIds.promocodes;

    const onMouseMove = useCallback(() => {
        if (!isDraggingOver && isDragging) {
            setDraggingOver(true);
        }
    }, [isDragging, isDraggingOver]);

    const handleMouseLeave = useCallback(() => setDraggingOver(false), []);

    const handleStopDrag = useCallback(() => {
        if (!isDragging) {
            return;
        }

        dispatch(setDragging(false));
        const isValidItems = !itemsToDrop.some(isDomainFolder);

        if (!isDraggingOver || !isValidItems || !isAllowedToDrop) {
            dispatch(showSnackbarAction({
                text: 'Невозможно переместить',
                type: SnackbarTypes.failure,
                id: 'drop-error',
                closable: true,
            }));
            return;
        }

        if (storage === EStorageType.trashbin) {
            toolbarActions.remove();
            return;
        }

        moveItemsDialog(itemsToDrop, item);
    }, [dispatch, itemsToDrop, isDragging, isDraggingOver, isAllowedToDrop, storage, item]);

    const handleMouseMove = useMemo(() => throttle(onMouseMove, 300), [onMouseMove]);

    return { isDraggingOver, handleMouseMove, handleMouseLeave, handleStopDrag, isAllowedToDrop };
};
